// extracted by mini-css-extract-plugin
export default {"hover":"styles_hover__WPnJW","expandButton":"styles_expandButton__qdDXV"};